module.exports = __webpack_public_path__ + "assets/img/money-pl.a08d6be1.png";